import React from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import QuestionMark from "../../../assets/Icon/QuestionMark";
import useHover from "../../../hooks/useHover";

interface TooltipButtonProps {
  icon: any;
  title: string;
  placement?:
    | "top"
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | undefined;
}

const TooltipButton: React.FC<TooltipButtonProps> = ({
  title = "",
  placement = "top",
  icon,
}) => {
  const [hovered, eventHandlers] = useHover();

  return (
    <Tooltip open={hovered} title={title} placement={placement}  >
      <div className='d-inline-block' {...eventHandlers}>
        <IconButton disabled={!hovered} >{icon}</IconButton>
      </div>
    </Tooltip>
  );
};
export default TooltipButton;
